var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlights3 = function SvgHighlights3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "highlights3_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 46.5 45.4",
    role: "img"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".highlights3_svg__st1{fill:#616e7d}.highlights3_svg__st2{fill:#aad4c8}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "highlights3_svg__Group_1130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "highlights3_svg__Path_8509",
    d: "M46.5 30.4c-3.3 0-5.4-2.1-7.9-3.8-1.9-1.5-4.3-2.3-6.7-2.3H21.8c-1 0-1.8.8-1.9 1.8s.8 1.8 1.8 1.9h6.5c1.5.2 2.5 1.6 2.2 3.1-.1.8-.6 1.5-1.4 1.9-.2.1-1.2.3-2.5.7l-2.4.6h-.2c-2.8.7-5.9 1.5-6.4 1.7-.3 0-.7 0-1-.1l-10-6.5L4.6 28c-.1-.1-.2-.1-.3-.2s-.3-.1-.4-.2c-.1 0-.2-.1-.4-.1h-.4c-.2 0-.4 0-.5.1C1.2 27.8 0 29 0 30.5q0 1.2.9 2.1c.2.2.5.4.7.5l.7.5 15.8 11.5.2.1c.4.1.7.2 1.1.2.2 0 .5 0 .7-.1h.1c5.4-1.4 16.5-4.2 21.7-5.5l.4-.1c1.4-.4 2.8-.6 4.3-.7v-8.6z",
    className: "highlights3_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "highlights3_svg__Path_8510",
    d: "M14.4 18.6c-.1-.2-.3-.3-.4-.5l-6.2 6.2.9.9 6.2-6.2c-.1-.1-.2-.1-.2-.2s-.2-.1-.3-.2",
    className: "highlights3_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "highlights3_svg__Path_8511",
    d: "M14.7 2.5c-.1-.1-.2-.2-.3-.2-4.3 4.3-4.5 11.3-.4 15.9.1.2.3.3.4.5.1.1.2.2.3.2s.2.1.2.2c4.6 4.1 11.5 3.9 15.9-.4-3.9-3.9-10.2-4.5-14.7-1.3 3.1-4.7 2.5-10.9-1.4-14.9",
    className: "highlights3_svg__st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "highlights3_svg__Path_8512",
    d: "M18.8 11.8c-.2.9-.2 1.7-.2 2.6h.4c7.8-.2 14-6.6 14-14.4-7 0-13 5-14.2 11.8",
    className: "highlights3_svg__st2"
  }))));
};
export default SvgHighlights3;